"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnchorLink = AnchorLink;
var _react = _interopRequireDefault(require("react"));
var _gatsby = require("gatsby");
var _utils = require("../utils");
var _types = require("../types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function AnchorLink(_ref) {
  var to = _ref.to,
    title = _ref.title,
    children = _ref.children,
    className = _ref.className,
    _ref$stripHash = _ref.stripHash,
    stripHash = _ref$stripHash === void 0 ? false : _ref$stripHash,
    other = _objectWithoutProperties(_ref, ["to", "title", "children", "className", "stripHash"]);
  var linkProps = {
    to: stripHash ? (0, _utils.stripHashedLocation)(to) : to,
    onClick: function onClick(e) {
      if (other.onClick) other.onClick();
      stripHash ? (0, _utils.handleStrippedLinkClick)(to, e) : (0, _utils.handleLinkClick)(to, e);
    }
  };
  /**
   * Optional props
   */

  if (title) linkProps.title = title;
  if (className) linkProps.className = className;
  return _react["default"].createElement(_gatsby.Link, linkProps, Boolean(children) ? children : title);
}
AnchorLink.propTypes = _types.anchorLinkTypes;